import React from 'react';

export const ReactTableFilter = ({ column }) => {
    const { filterValue, setFilter } = column;
    return (
        <span className="mx-auto pt-2">
            <input className="form-control form-control-sm" style={{ minWidth: "70px" }} value={filterValue || ''} onChange={(e) => setFilter(e.target.value)} />
        </span>
    )
}